import filter from "@domains/utils/filter";
import sort, { ESortOrder, dateSort, stringSort_depricated, } from "@domains/utils/sort";
export class TransactionHistoryCommonUseCase {
    constructor(searchUsecase, filterUsecase, sortUseCase) {
        this.searchUsecase = searchUsecase;
        this.filterUsecase = filterUsecase;
        this.sortUseCase = sortUseCase;
    }
    async getModifiedData(THData, combinedState) {
        try {
            let searchData = this.searchUsecase.getSearchData(THData, combinedState.searchState);
            let filterData = this.filterUsecase.getFilteredData(searchData, combinedState.filterUiState);
            return filterData;
        }
        catch (error) {
            return Object.assign(Object.assign({}, THData), { transactionHistory: Object.assign({}, THData.transactionHistory) });
        }
    }
}
export class FilterUseCase {
    getFilteredData(THData, { simpleFilter, assetFilter, underlyingAsset }) {
        let FilterData = [
            ...THData.transactionHistory,
        ];
        let simpleFilterEditableFState = {
            FilterApplied: false,
            FilterState: [{ key: "editable", value: true }],
        };
        let simpleFilterActionFState = {
            FilterApplied: false,
            FilterState: [{ key: "action", value: [] }],
        };
        let assetFilterFState = {
            FilterApplied: false,
            FilterState: [{ key: "edelweissProductShortCode", value: [] }],
        };
        let productAssetFilterFState = {
            FilterApplied: false,
            FilterState: [{ key: "txnFlag", value: [] }],
        };
        simpleFilterEditableFState = this.detectSelectedFilter(Object.assign(Object.assign({}, simpleFilter), { filters: simpleFilter.filters.slice(0, 1) }), "editable");
        simpleFilterActionFState = this.detectSelectedFilter(Object.assign(Object.assign({}, simpleFilter), { filters: simpleFilter.filters.slice(1) }), "action");
        assetFilterFState = this.detectSelectedFilter(assetFilter, "edelweissProductShortCode");
        productAssetFilterFState = this.detectSelectedFilter(underlyingAsset, "txnFlag");
        if (simpleFilterActionFState.FilterApplied)
            FilterData = filter(FilterData, simpleFilterActionFState.FilterState);
        if (simpleFilterEditableFState.FilterApplied)
            FilterData = filter(FilterData, [
                { key: ["filterFlags", "editable"], value: true },
            ]);
        if (assetFilterFState.FilterApplied)
            FilterData = filter(FilterData, assetFilterFState.FilterState);
        if (productAssetFilterFState.FilterApplied)
            FilterData = filter(FilterData, productAssetFilterFState.FilterState);
        return Object.assign(Object.assign({}, THData), { transactionHistory: [...FilterData], FilterData: { simpleFilter, assetFilter, underlyingAsset } });
    }
    detectSelectedFilter(filter, initFilterStateKey) {
        var _a;
        if ((filter === null || filter === void 0 ? void 0 : filter.name) && ((_a = filter === null || filter === void 0 ? void 0 : filter.filters) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let applied = false;
            let filterState = [
                { key: initFilterStateKey, value: [] },
            ];
            filter.filters.forEach((filter) => {
                if (filter.selected) {
                    applied = true;
                    filterState[0].value.push(filter.key);
                }
            });
            return {
                FilterApplied: applied,
                FilterState: filterState,
            };
        }
    }
}
export class SearchUseCase {
    getSearchData(THData, searchData) {
        let transactionHistory = THData.transactionHistory;
        if (!!searchData) {
            transactionHistory =
                THData.transactionHistory.filter((txnDetails) => txnDetails.searchValue.toLowerCase().includes(searchData.toLowerCase()));
        }
        return Object.assign(Object.assign({}, THData), { transactionHistory: transactionHistory, SearchData: searchData });
    }
}
export class SortUseCase {
    getSortedData(THData, sortState) {
        let transactionHistory;
        if (sortState.sortName === "security")
            transactionHistory = stringSort_depricated(THData.transactionHistory, sortState.sortName, sortState.order);
        else if (sortState.sortName === "transactionDate")
            transactionHistory = dateSort(THData.transactionHistory, sortState.sortName, sortState.order);
        else
            transactionHistory = sort(THData.transactionHistory, sortState.sortName, sortState.order);
        let SortData = THData.SortData.map((e) => {
            return Object.assign(Object.assign({}, e), { order: sortState.sortName === e.sortName
                    ? sortState.order
                    : ESortOrder.UNCHANGED });
        });
        return Object.assign(Object.assign({}, THData), { transactionHistory: transactionHistory, SortData: SortData });
    }
}
